export const ViewStatuses = {
  VALID: 'VALID',
  INVALID: 'INVALID',
} as const;
